"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertSaveOrUpdateHandler = exports.useAlertDeleteHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
tslib_1.__exportStar(require("./types"), exports);
var useAlertDeleteHandler_1 = require("./useAlertDeleteHandler");
Object.defineProperty(exports, "useAlertDeleteHandler", { enumerable: true, get: function () { return useAlertDeleteHandler_1.useAlertDeleteHandler; } });
var useAlertSaveOrUpdateHandler_1 = require("./useAlertSaveOrUpdateHandler");
Object.defineProperty(exports, "useAlertSaveOrUpdateHandler", { enumerable: true, get: function () { return useAlertSaveOrUpdateHandler_1.useAlertSaveOrUpdateHandler; } });
//# sourceMappingURL=index.js.map